import { Entity, FieldType } from 'gossamer-unified';
import { SpecialtyGroupOptions } from './SharedOptions';

export interface SpecialtyRow {
  id: string;
  label: string;
  specialty_group_id: string;
}

export const Specialty: Entity<SpecialtyRow> = {
  id: 'Specialty',
  title: 'Specialty',
  service: 'main',
  rowLabel: (row: SpecialtyRow) => row.label,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.specialty',
  },
  security: [
    {
      role: 'all',
      action: 'read',
      access: 'all',
    },
  ],
  defaultSort: [['label', 'ASC']],
  defaultFilters: [
    { fieldId: 'label', operator: 'sw', value: '' },
    { fieldId: 'specialty_group_id', operator: 'eq', value: '' },
  ],

  fields: {
    id: {
      seq: 10,
      type: FieldType.Text,
      label: 'Id',
      mandatory: true,
      maxLength: 40,
    },
    label: {
      seq: 20,
      type: FieldType.Text,
      label: 'Label',
      mandatory: true,
      listColumn: true,
      maxLength: 255,
    },
    specialty_group_id: {
      seq: 30,
      label: 'Specialty Group',
      type: FieldType.Options,
      listColumn: true,
      options: SpecialtyGroupOptions,
    },
  },
};
